const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
const LIGHTEN_AMOUNT = 0.4; // mix toward white

const expand = (hex: string) =>
  hex.length === 4
    ? hex
        .slice(1)
        .split('')
        .map((c) => c + c)
        .join('')
    : hex.slice(1);

const lighten = (hex: string) => {
  const full = expand(hex);
  const channel = (start: number) => {
    const c = parseInt(full.slice(start, start + 2), 16);
    const mixed = Math.round(c + (255 - c) * LIGHTEN_AMOUNT);
    return mixed.toString(16).padStart(2, '0');
  };
  return `#${channel(0)}${channel(2)}${channel(4)}`;
};

export interface AccentSpotlightShades {
  from: string;
  to: string;
}

export function accentSpotlightShades(accentColor: string): AccentSpotlightShades {
  if (!HEX.test(accentColor)) {
    return { from: accentColor, to: accentColor };
  }
  return { from: accentColor, to: lighten(accentColor) };
}
